// src/components/Websites/WebsiteItem.js
import React from 'react';

const WebsiteItem = ({ website }) => {
  return (
    <div className="website-item">
      <div className="website-thumbnail-wrapper">
        <img src={website.thumbnail} alt={website.title} className="website-thumbnail" />
        <div className="website-hover">
          <h3>{website.title}</h3>
          <p>{website.description}</p>
          <a href={website.url} target="_blank" rel="noopener noreferrer" className="website-link">
            Visit Website
          </a>
        </div>
      </div>
    </div>
  );
};

export default WebsiteItem;